.item-with-icon {
    display: inline-flex;
    align-items: center;
    max-width: 100%;
}
